export default __webpack_public_path__ + "static/media/ATTAleckSans_Md.16f8b09c.ttf";